import { ReactElement } from "react";

interface CountLabelProps {
  amount?: number;
}

export function CountLabel({ amount }: CountLabelProps): ReactElement | null {
  if (amount === undefined || amount === null) {
    return <>-</>;
  }
  return <>{amount.toLocaleString()} 回</>;
}
